export const CesiumIonDefaultAccessToken = ''
export const TianDiTuToken = ''